/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CodeInterpreterOutput,
  CodeInterpreterOutput$inboundSchema,
  CodeInterpreterOutput$Outbound,
  CodeInterpreterOutput$outboundSchema,
} from "./codeinterpreteroutput.js";

export const CodeInterpreterToolCallStatus = {
  InProgress: "in_progress",
  Completed: "completed",
  Incomplete: "incomplete",
  Interpreting: "interpreting",
  Failed: "failed",
} as const;
export type CodeInterpreterToolCallStatus = ClosedEnum<
  typeof CodeInterpreterToolCallStatus
>;

/**
 * Code interpreter call item: A tool-call record for code execution, including code, container, outputs, and status.
 */
export type CodeInterpreterToolCall = {
  type: "code_interpreter_call";
  id: string;
  code: string | null;
  containerId: string;
  outputs: Array<CodeInterpreterOutput> | null;
  status: CodeInterpreterToolCallStatus;
};

/** @internal */
export const CodeInterpreterToolCallStatus$inboundSchema: z.ZodNativeEnum<
  typeof CodeInterpreterToolCallStatus
> = z.nativeEnum(CodeInterpreterToolCallStatus);
/** @internal */
export const CodeInterpreterToolCallStatus$outboundSchema: z.ZodNativeEnum<
  typeof CodeInterpreterToolCallStatus
> = CodeInterpreterToolCallStatus$inboundSchema;

/** @internal */
export const CodeInterpreterToolCall$inboundSchema: z.ZodType<
  CodeInterpreterToolCall,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("code_interpreter_call"),
  id: z.string(),
  code: z.nullable(z.string()),
  container_id: z.string(),
  outputs: z.nullable(z.array(CodeInterpreterOutput$inboundSchema)),
  status: CodeInterpreterToolCallStatus$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "container_id": "containerId",
  });
});
/** @internal */
export type CodeInterpreterToolCall$Outbound = {
  type: "code_interpreter_call";
  id: string;
  code: string | null;
  container_id: string;
  outputs: Array<CodeInterpreterOutput$Outbound> | null;
  status: string;
};

/** @internal */
export const CodeInterpreterToolCall$outboundSchema: z.ZodType<
  CodeInterpreterToolCall$Outbound,
  z.ZodTypeDef,
  CodeInterpreterToolCall
> = z.object({
  type: z.literal("code_interpreter_call"),
  id: z.string(),
  code: z.nullable(z.string()),
  containerId: z.string(),
  outputs: z.nullable(z.array(CodeInterpreterOutput$outboundSchema)),
  status: CodeInterpreterToolCallStatus$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    containerId: "container_id",
  });
});

export function codeInterpreterToolCallToJSON(
  codeInterpreterToolCall: CodeInterpreterToolCall,
): string {
  return JSON.stringify(
    CodeInterpreterToolCall$outboundSchema.parse(codeInterpreterToolCall),
  );
}
export function codeInterpreterToolCallFromJSON(
  jsonString: string,
): SafeParseResult<CodeInterpreterToolCall, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CodeInterpreterToolCall$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CodeInterpreterToolCall' from JSON`,
  );
}
